import { Table, TableBody } from "../../../design/table";
import { Heading } from "../../../design/heading";
import { useTask } from "../../../contexts/TaskContext";
import EmptyStateView from "../../../components/EmptyStateView";
import TaskListItem from "../../TaskListPage/components/TaskListItem";

interface TaskListProps {}

const TaskList: React.FC<TaskListProps> = ({}) => {
  const { tasks } = useTask();

  const filteredTasks = tasks.filter((task) => !task.isCompleted).slice(0, 3);

  return (
    <div className="p-4 pt-4 my-4 bg-white border rounded-md shadow-lg dark:bg-black">
      <Heading>Tasks</Heading>
      {filteredTasks.length > 0 ? (
        <Table>
          <TableBody>
            {filteredTasks.map((task) => (
              <TaskListItem key={task._id} task={task} />
            ))}
          </TableBody>
        </Table>
      ) : (
        <EmptyStateView title="No Tasks Found" message="There are no tasks" />
      )}
    </div>
  );
};
export default TaskList;
